export const getIdKecamatan = (subDistrics, subDistric) => {
    return subDistrics.filter(item => item.nama === subDistric)
}